import { createSessionRecheck } from '@highlight-cp/auth-client/session-recheck';

// One per app: the store adds the middleware, and the auth provider registers the recheck.
export const { middleware: sessionRecheckMiddleware, useSessionRecheck } = createSessionRecheck();
